import styled from 'styled-components';

export const OverlayWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  z-index: 1;
  position: fixed;
  display: inline-block;
  background-color: rgba(34, 34, 34, 0.1);
  left: 0;
  svg {
    display: block;
    margin: 0 auto;
    margin-top: 40vh;
  }
`;
